export default __webpack_public_path__ + "static/media/nofav-icon.92d76db0.svg";